module.exports = __webpack_public_path__ + "media/src/images/abouts/icons/glyph-logo_May2016-0e84d5926187e7a3b785febd3a55bf1d.png";